import { Tabela } from "shared/components/table/Tabela";
import { RenderRowsInadimplencia } from "./RenderRowsInadimplencia";
import { TableColumn } from "types/table/TableColumn";
import { useEffect, useState } from "react";
import { useGestaoCobrancaCadastroContext } from "../../../context/gestaoCobranca/GestaoCobrancaCadastroContext";
import { InadimplenciaDTO } from "types/dto/RegistroInadimplenciaDTO";
import { RequestInadimplencias } from "types/request/RequestInadimplencias";
import { useGetInadimplencias } from "hooks/contaReceber/useGetInadimplencias";
import { queryClient } from "shared/util/queryClient";
import { Page } from "types/dto/Page";
import { OpcoesSelecionaveisCheckBox } from "types/OpcoesSelecionaveisCheckBoxType";

const TabelaCobrancasEmAberto = () => {
  const [ordenarPorColuna, setOrdenarPorColuna] = useState<string>("nossoNumero,dataVencimento");
  const [ordenacaoAscOuDesc, setOrdenacaoAscOuDesc] = useState<"ASC" | "DESC">("ASC");
  const [sortString, setSortString] = useState<string>("nossoNumero,dataVencimento,ASC");
  const [paginaAtual, setPaginaAtual] = useState(1);

  const {
    selecionarTodasDaPagina,
    inadimplenciasSelecionadas,
    toggleCheckbox,
    condominioId,
    unidadeId,
    possuiPermissaoIniciarAcordo,
    setInadimplencias,
    setInadimplenciasSelecionadas,
    opcaoSelecionadaCheckBox,
    setOpcaoSelecionadaCheckBox,
  } = useGestaoCobrancaCadastroContext();

  const [allCheckBoxCheckted, setAllCheckBoxChecked] = useState<boolean>(false);

  const params = {
    size: 10,
    page: paginaAtual - 1,
    sort: sortString,
    unidadeId: unidadeId,
    condominioId: condominioId,
  } as RequestInadimplencias;
  const { data: inadimplenciasPage, isFetching } = useGetInadimplencias(params);
  const inadimplencias: InadimplenciaDTO[] = inadimplenciasPage?.content || [];

  useEffect(() => {
    if (opcaoSelecionadaCheckBox !== "TODAS_FILTRO") {
      if (inadimplenciasSelecionadas.length !== inadimplencias.length) {
        setAllCheckBoxChecked(false);
      } else if (inadimplenciasSelecionadas.length === inadimplencias.length && inadimplencias.length > 0) {
        setAllCheckBoxChecked(true);
      }

      const contemTodas = inadimplencias.every((inadimplencia) =>
        inadimplenciasSelecionadas.includes(inadimplencia.id)
      );

      if (contemTodas && inadimplencias.length > 0) {
        setAllCheckBoxChecked(true);
      } else {
        setAllCheckBoxChecked(false);
      }
    }
  }, [inadimplenciasSelecionadas, inadimplencias]);

  useEffect(() => {
    const inadimplenciaCurrentPage = queryClient.getQueryData([
      "inadimplencias",
      unidadeId,
      paginaAtual - 1,
      sortString,
    ]) as Page<InadimplenciaDTO>;

    setInadimplencias(inadimplenciaCurrentPage?.content);
  }, [paginaAtual, unidadeId]);

  useEffect(() => {
    setInadimplenciasSelecionadas([]);
  }, [unidadeId]);

  const createColumnsInadimplencia = (): TableColumn[] => {
    return [
      {
        id: "nossoNumero,dataVencimento",
        label: "Nosso número",
        isOrdenavel: true,
        width: "135px",
      },
      {
        id: "dataVencimento",
        label: "Vencimento",
        isOrdenavel: true,
        width: "135px",
      },
      {
        id: "total",
        label: "Valor (R$)",
        width: "90px",
      },
      {
        id: "atraso",
        label: "Atraso",
        width: "90px",
      },
      {
        id: "juros",
        label: "Juros (R$)",
        width: "90px",
      },
      {
        id: "multa",
        label: "Multa (R$)",
        width: "90px",
      },
      {
        id: "correcao",
        label: "Correção (R$)",
        width: "110px",
      },
      {
        id: "honorario",
        label: "Honorários (R$)",
        width: "120px",
      },
      {
        id: "total",
        label: "Total (R$)",
        width: "90px",
      },
    ];
  };

  const ordenarRegistros = (idColuna: string) => {
    const novaOrdenacao =
      !ordenacaoAscOuDesc || ordenarPorColuna !== idColuna || ordenacaoAscOuDesc === "DESC" ? "ASC" : "DESC";
    setOrdenacaoAscOuDesc(novaOrdenacao);
    setOrdenarPorColuna(idColuna);
    setSortString(`${idColuna},${novaOrdenacao}`);
  };

  const handleChangeCheckBox = (opcao: OpcoesSelecionaveisCheckBox) => {
    if (opcao === "TODAS_PAGINA") {
      selecionarTodasDaPagina();
    } else if (opcao === "TODAS_FILTRO") {
      setInadimplenciasSelecionadas([]);
      setAllCheckBoxChecked(true);
    } else {
      setInadimplenciasSelecionadas([]);
      setAllCheckBoxChecked(false);
    }
    setOpcaoSelecionadaCheckBox(opcao);
  };

  return (
    <Tabela
      id="tabela-inadimplencia"
      colunas={createColumnsInadimplencia()}
      ordernarPorColuna={ordenarPorColuna}
      ordenacaoAscOuDesc={ordenacaoAscOuDesc}
      ordenarRegistrosFunction={(idColuna) => ordenarRegistros(idColuna)}
      onChangePageFunction={(paginaAtual: number) => setPaginaAtual(paginaAtual)}
      paginaAtual={paginaAtual}
      quantidadeDePaginas={inadimplenciasPage?.totalPages ?? 0}
      renderCheckBox={possuiPermissaoIniciarAcordo}
      onChangeCheckBox={handleChangeCheckBox}
      tipoCheckBox={"SELECT_OPTIONS"}
      isLoading={isFetching}
      quantidadeDeRegistros={inadimplenciasPage?.totalElements}
      checkedCheckBox={allCheckBoxCheckted}
    >
      <RenderRowsInadimplencia
        opcaoSelecionadaCheckBox={opcaoSelecionadaCheckBox}
        registros={inadimplencias}
        checkBoxClick={toggleCheckbox}
      />
    </Tabela>
  );
};

export default TabelaCobrancasEmAberto;
